"use client";
import { Box, Typography } from "@mui/material";
import React from "react";
import { Loader } from "../genericComponents/MainLoader/Loader";
import Link from "next/link";

export const SalonTymCoinsVisit = () => {
  const [loading, setLoading] = React.useState(false);

  const handleNavigate = () => {
    setLoading(true);
  };
  const coinBenefits = ["Earn on every order", "Redeem in store", "Member-only drops"];

  return (
    <>
      {loading && <Loader />}
      <Box
        sx={{
          width: "var(--salontym-content-width)",
          textAlign: "center",
          height: "auto",
          margin: "0 auto var(--salontym-section-gap)",
          padding: { xs: "0.95rem", sm: "1.15rem" },
          borderRadius: { xs: "28px", sm: "34px" },
          background:
            "linear-gradient(135deg, rgba(255,255,255,0.96) 0%, rgba(246,251,248,0.94) 58%, rgba(255,247,235,0.96) 100%)",
          border: "1px solid rgba(18,53,36,0.08)",
          boxShadow: "0 22px 60px rgba(18,53,36,0.08)",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "-4rem",
            right: "-3rem",
            width: "13rem",
            height: "13rem",
            borderRadius: "999px",
            background:
              "radial-gradient(circle, rgba(223,246,232,0.9) 0%, rgba(223,246,232,0) 70%)",
          }}
        />
        <Link
          prefetch={false}
          href={"/store"}
          passHref
          style={{ textDecoration: "none", color: "inherit" }}
          onClick={handleNavigate}
        >
          <Box
            sx={{
              position: "relative",
              zIndex: 1,
              display: "grid",
              gridTemplateColumns: { xs: "1fr", md: "1.2fr 0.95fr" },
              gap: { xs: "1.2rem", md: "1.5rem" },
              alignItems: "stretch",
            }}
          >
            <Box
              sx={{
                textAlign: "left",
                padding: { xs: "0.1rem 0.1rem 0", sm: "0.15rem 0.25rem 0" },
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <Typography className="section-eyebrow">Rewards and store</Typography>
              <Typography
                sx={{
                  marginTop: "0.65rem",
                  fontFamily: "var(--salontym-font-display)",
                  fontSize: { xs: "1.8rem", sm: "2.6rem" },
                  lineHeight: 1.02,
                  color: "#102117",
                  maxWidth: "14ch",
                  textAlign: "left",
                }}
              >
                Spend smarter with SalonTym Coin perks
              </Typography>
              <Typography
                sx={{
                  marginTop: "0.75rem",
                  color: "#5e6d63",
                  maxWidth: "40rem",
                  lineHeight: 1.75,
                  textAlign: "left",
                }}
              >
                Shop, save, and unlock added value through a rewards experience
                designed to feel premium from the first tap.
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "0.75rem",
                  marginTop: "0.85rem",
                }}
              >
                {coinBenefits.map((item) => (
                  <Box
                    key={item}
                    sx={{
                      padding: "0.8rem 1rem",
                      borderRadius: "999px",
                      background: "rgba(31,122,77,0.08)",
                      border: "1px solid rgba(31,122,77,0.14)",
                      color: "#123524",
                      fontWeight: 700,
                      fontSize: "0.92rem",
                    }}
                  >
                    {item}
                  </Box>
                ))}
              </Box>
            </Box>
            <Box
              sx={{
                borderRadius: { xs: "24px", sm: "28px" },
                background:
                  "linear-gradient(145deg, #102117 0%, #17442d 45%, #f2c46c 160%)",
                padding: { xs: "0.9rem", sm: "1rem" },
                minHeight: { xs: "240px", sm: "285px" },
                display: "grid",
                gridTemplateRows: "auto 1fr auto",
                gap: "0.8rem",
                color: "#fff8f1",
                boxShadow: "0 24px 50px rgba(18,53,36,0.16)",
              }}
            >
              <Box
                sx={{
                  width: "fit-content",
                  padding: "0.45rem 0.8rem",
                  borderRadius: "999px",
                  background: "rgba(255,255,255,0.12)",
                  border: "1px solid rgba(255,255,255,0.14)",
                  fontSize: "0.76rem",
                  fontWeight: 800,
                  letterSpacing: "0.08em",
                  textTransform: "uppercase",
                }}
              >
                SalonTym Coin
              </Box>
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                  gap: "0.7rem",
                  alignContent: "center",
                }}
              >
                <Box
                  sx={{
                    padding: "0.85rem",
                    borderRadius: "20px",
                    background: "rgba(255,255,255,0.12)",
                    backdropFilter: "blur(12px)",
                  }}
                >
                  <Typography sx={{ fontSize: "2.2rem", fontFamily: "var(--salontym-font-display)" }}>
                    3x
                  </Typography>
                  <Typography sx={{ color: "rgba(255,248,241,0.72)" }}>
                    faster reward value on recurring care
                  </Typography>
                </Box>
                <Box
                  sx={{
                    padding: "0.85rem",
                    borderRadius: "20px",
                    background: "rgba(255,255,255,0.12)",
                    backdropFilter: "blur(12px)",
                  }}
                >
                  <Typography sx={{ fontSize: "2.2rem", fontFamily: "var(--salontym-font-display)" }}>
                    100%
                  </Typography>
                  <Typography sx={{ color: "rgba(255,248,241,0.72)" }}>
                    digital wallet feel with premium store access
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  padding: "0.9rem",
                  borderRadius: "22px",
                  background: "linear-gradient(135deg, rgba(255,255,255,0.95), rgba(255,244,225,0.92))",
                  color: "#102117",
                }}
              >
                <Typography sx={{ fontWeight: 800, fontSize: "1.05rem" }}>
                  Open the store and explore rewards-first shopping
                </Typography>
                <Typography sx={{ marginTop: "0.35rem", color: "#5e6d63", lineHeight: 1.65 }}>
                  Products, bundles, and redemptions designed to feel like a membership ecosystem.
                </Typography>
              </Box>
            </Box>
          </Box>
        </Link>
      </Box>
    </>
  );
};
